<template>
    <div style="display: none;">
        <div ref="cnt">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { type, deepCopy } from '../../utils/assist'
import Configurable from '../a-map/configurable'
import EventAgent from '../a-map/eventAgent'

// 覆盖物-标记
export default {
    name: "AMapMarker",

    mixins: [Configurable, EventAgent],

    inject: {
        amap: { default: null }
    },

    data() {
        return {
            marker: null
        }
    },

    props: {
        // 点标记在地图上显示的位置，默认为地图中心点
        position: {
            type: [Array, Object],
            validator(val) {
                // 若position有值，则必须为合法的经纬度组合
                if (type(val) == "array") {
                    var [lng, lat] = val

                    if (isNaN(lng) || isNaN(lat)) {
                        return false
                    }
                }

                return true
            }
        },
        // 设置点标记锚点
        anchor: {
            type: String,
            default: 'top-left',
            validator(val) {
                return ["top-left", "top-center", "top-right", "middle-left", "center", "middle-right", "bottom-left", "bottom-center", "bottom-right"].indexOf(val) >= 0
            }
        },
        // 点标记显示位置偏移量
        offset: {
            type: Object, // AMap.Pixel
        },
        // 需在点标记中显示的图标
        icon: {
            type: [String, Object], // AMap.Icon
        },
        // 点标记显示内容，可以是HTML要素字符串或者HTML DOM对象。content有效时，icon属性将被覆盖
        content: {
            type: [String, Object],
        },
        // 鼠标点击时marker是否置顶
        topWhenClick: {
            type: Boolean,
            default: false
        },
        // 是否将覆盖物的鼠标或touch等事件冒泡到地图上 
        bubble: {
            type: Boolean,
            default: false
        },
        // 设置点标记是否可拖拽移动
        draggable: {
            type: Boolean,
            default: false
        },
        // 设置拖拽点标记时是否开启点标记离开地图的效果
        raiseOnDrag: {
            type: Boolean,
        },
        // 指定鼠标悬停时的鼠标样式，自定义cursor
        cursor: {
            type: String,
        },
        // 点标记是否可见
        visible: {
            type: Boolean,
            default: true
        },
        // 点标记的叠加顺序
        zIndex: {
            type: Number,
            default: 100
        },
        // 点标记的旋转角度，广泛用于改变车辆行驶方向
        angle: {
            type: Number,
        },
        // 是否自动旋转
        autoRotation: {
            type: Boolean,
            default: false
        },
        // 点标记的动画效果
        animation: {
            type: String,
            default: "AMAP_ANIMATION_NONE",
            validator(val) {
                return ["AMAP_ANIMATION_NONE", "AMAP_ANIMATION_DROP", "AMAP_ANIMATION_BOUNCE"].indexOf(val) >= 0
            }
        },
        // 点标记阴影，不设置该属性则点标记无阴影
        shadow: {
            type: Object, // AMap.Icon
        },
        // 鼠标滑过点标记时的文字提示，不设置则鼠标滑过点标无文字提示
        title: {
            type: String,
        },
        // 点标记是否可点击
        clickable: {
            type: Boolean,
            default: true,
        },
        // 设置Marker的可点击区域
        shape: {
            type: Object, // AMap.MarkerShape
        },
        // 用户自定义数据
        extData: {
            type: Object,
            dfeault: () => ({})
        },
        // 添加文本标注
        label: {
            type: Object, // {content,offset,direction}
        },
    },
    
    methods: {
        initMarker() {
            if (AMap && AMap.Marker) {
                this.marker = new AMap.Marker(Object.assign({}, this.config, {
                    content: this.$slots.default && this.$refs.cnt || this.content,
                }))

                // 事件监听
                this.startAgent(this.marker)

                return this.marker
            } else {
                return new Error("AMap.Marker插件未加载")
            }
        },
        resolve() {
            return "marker"
        },
    },

    watch: {
        position(val) {
            if (this.marker) {
                this.marker.setPosition(val)
            }
        },
        offset(val) {
            if (this.marker) {
                this.marker.setOffset(val)
            }
        },
        animation(val) {
            if (this.marker) {
                this.marker.setAnimation(val)
            }
        },
        angle(val) {
            if (this.marker) {
                this.marker.setAngle(val)
            }
        },
        label(val) {
            if (this.marker) {
                this.marker.setLabel(val)
            }
        },
        zIndex(val) {
            if (this.marker) {
                this.marker.setzIndex(val)
            }
        },
        icon(val) {
            if (this.marker) {
                this.marker.setIcon(val)
            }
        },
        draggable(val) {
            if (this.marker) {
                this.marker.setDraggable(val)
            }
        },
        cursor(val) {
            if (this.marker) {
                this.marker.setCursor(val)
            }
        },
        content(val) {
            if (this.marker) {
                this.marker.setContent(val)
            }
        },
    },

    created() {
        this.$watch(function() {
            return this.amap.load
        }, function(load) {
            // map 创建完毕
            if (load) {
                // AMap的直接子级
                if (this.$parent.$options.name == "AMap") {
                    // 取消config bubble
                    this.configBubble = false

                    var marker = this.initMarker()

                    if (type(marker) == "error") {
                        throw marker
                    }

                    this.amap.map.add(marker)
                    this.amap.overlay.push(marker)
                }
            }
        }, {
            immediate: true
        })
    },

    beforeDestroy() {
        if (this.marker) {
            // 从amap移除
            this.amap.map.remove(this.marker)
            this.amap.overlay.splice(this.amap.overlay.indexOf(this.marker), 1)
            // 事件解绑
            this.stopAgent(this.marker)
        }
    }
}
</script>